module.exports = __webpack_public_path__ + "img/3-1.bac7a608.svg";